<template>
  <div>
    <div v-if="$store.state.miscData.DisplayImage" id="titleSection" class="white row1">
      <div id="jobImageDiv" v-if="$store.state.miscData.DisplayImage">
        <b-img
          v-if="job.Image.length >= 1"
          thumbnail
          loading="lazy"
          fluid
          v-bind:src="job.Image"
          alt="Image 1"
          class="pb-1 pt-1 rounded jobImage"
        ></b-img>
        <b-img
          v-else
          thumbnail
          rounded
          src="../../assets/placeholder-975x650.png"
          fluid
          alt="Responsive image"
          class="pb-1 pt-1 rounded jobImage"
        ></b-img>
      </div>
      <div id="titleDivWithImage">
        <h4 id="titleWithImage">{{job.Name}}</h4>
      </div>
    </div>
    <div v-else class="white">
      <div id="titleDivNoImage">
        <h4 id="titleNoImage">{{job.Name}}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopJobTitleSection",
  props: {
    job: Object
  }
};
</script>

<style scoped>
/* shared */
#jobImageDiv {
  display: flex;
  align-items: center; /* Vertical center alignment */
  justify-content: center; /* Horizontal center alignment */
  /* border-right: 4px solid black; */
}
#titleSection {
  padding: 20px;
}

#jobImageDiv {
  padding-right: 15px;
}
.jobImage {
  max-height: 160px;
}
#titleDivWithImage {
  display: flex;
  align-items: center; /* Vertical center alignment */
  justify-content: center; /* Horizontal center alignment */
}

#titleWithImage {
  align-items: center;
}

#titleDivNoImage {
  height: 140px;
  display: flex;
  align-items: center;
}


#titleNoImage {
  flex: 1; /* This make p take the full width of column*/
  text-align: center;
}

/* > 992px*/
@media screen and (min-width: 992px) {
}

/* =< 991 */
@media screen and (max-width: 991px) {
  #titleWithImage {
    font-size: 20px;
    height: 140px;
    display: flex;
    align-items: center;
  }
  #titleSection {
    padding: 20px;
  }
  .jobImage {
    max-height: 140px;
  }

  #jobImageDiv {
    min-width: 35%
  }
}
</style>